<script>
import { mapState } from 'vuex'
import { SocmedForm } from '@src/forms/Property'
import Request from '@src/mixins/request'

export default {
  mixins: [Request],

  props: {
    name: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {},
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
  },

  mounted() {
    this.form = new SocmedForm(this.$route.params.property)
  },

  methods: {
    onSubmit() {
      this.updateData({
        url: this.endpoint.property.updateSocmed,
        data: {
          id: this.currentProperty.id,
          update: this.form,
        },
      })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseCard>
      <BaseControlInput label="Instagram link">
        <VTextField
          v-model="form.instagram"
          label="Instagram link"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Facebook link">
        <VTextField
          v-model="form.facebook"
          label="Facebook link"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Twitter link">
        <VTextField v-model="form.twitter" label="Twitter link" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="YouTube link">
        <VTextField v-model="form.youtube" label="YouTube link" color="gold" />
      </BaseControlInput>

      <VBtn
        slot="card-actions-right"
        color="gold"
        type="submit"
        :loading="loading"
        dark
      >
        Update
      </VBtn>
    </BaseCard>
  </VForm>
</template>
